import { Box, Chip } from "@mui/material";
import { EquipmentEnum } from "../enums/equipment-enum";
import { equipmentsStatusColorMap } from "../utils/statusColorMap/index";

// Lista explícita para manter a ordem
const orderedStatusKeys = [
  EquipmentEnum.RENTED,
  EquipmentEnum.AWAITING_SHIPMENT,
  EquipmentEnum.AWAITING_REPLACEMENT,
  EquipmentEnum.RESERVED,
  EquipmentEnum.INTERNAL_USE,
  EquipmentEnum.MAINTENANCE,
  EquipmentEnum.WARRANTY,
  EquipmentEnum.AVAILABLE,
  EquipmentEnum.DISABLED,
  EquipmentEnum.ON_THE_WAY,
  EquipmentEnum.RETURNED,
];

export default function RowStatus() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1.5,
        width: "100%",
        justifyContent: "flex-start",
      }}>
      {orderedStatusKeys.map((key, index) => {
        const item = equipmentsStatusColorMap[key];
        return (
          <Chip
            key={index}
            label={item.label}
            sx={{
              backgroundColor: item.bgColor,
              color: item.color,
              fontSize: 16,
              fontWeight: "bold",
              borderRadius: 2,
              ...(item.label === "Disponível para locação" && {
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)",
              }),
            }}
          />
        );
      })}
    </Box>
  );
}
